import { BetweenPipe } from './between.pipe';
import { ReplaceAllPipe } from './replace-all.pipe';
import { TrustAsCssPipe } from './trust-as-css.pipe';
import { TrustAsHtmlPipe } from './trust-as-html.pipe';
import { TrustAsUrlPipe } from './trust-as-url.pipe';

export {
    BetweenPipe,
    ReplaceAllPipe,
    TrustAsCssPipe,
    TrustAsHtmlPipe,
    TrustAsUrlPipe
}

export const APP_BASE_LIB_PIPES: any[] = [
    BetweenPipe,
    ReplaceAllPipe,
    TrustAsCssPipe,
    TrustAsHtmlPipe,
    TrustAsUrlPipe
];


